import styled from "styled-components";
import { motion } from "framer-motion";

export const FloatingButton = styled(motion.button)`
  position: fixed;
  bottom: 96px;
  right: 24px;
  z-index: 3000;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
`;
